import * as React from 'react';
import TableCell from '@mui/material/TableCell';
import { Chip, Typography, Box } from '@mui/material';
import moment from 'moment';
import { WARNING_DAYS } from '../../../config';
import { hasValidUSTime } from '../../../utils';

export const DateChipCell = ({
  due: date,
  title,
  ...rest
}: {
  due?: string;
  title?: string;
}) => {
  const zeroTime = !hasValidUSTime(date);
  if (date) {
    const daysRemaining = moment(date).diff(moment.now(), 'days');
    const formattedDate = moment(date)
      .local()
      .format(!zeroTime ? 'MMM D YYYY h:mm a' : 'MMM D YYYY');
    const color =
      daysRemaining <= WARNING_DAYS && daysRemaining >= 0
        ? 'warning'
        : daysRemaining < 0
        ? 'error'
        : 'secondary';
    return (
      <Box sx={{ cursor: 'pointer' }}>
        {color || title ? (
          <>
            {title && <Typography variant="body2">{title}</Typography>}
            {color && (
              <Chip
                size="small"
                variant="outlined"
                color={color}
                label={formattedDate}
                sx={{ cursor: 'pointer' }}
              />
            )}
          </>
        ) : (
          <Typography variant="body2">{formattedDate}</Typography>
        )}
      </Box>
    );
  } else if (title) {
    return <Typography variant="body2">{title}</Typography>;
  } else {
    return <div />;
  }
};
